// extracted by mini-css-extract-plugin
export default {"heading":"_j-z","list":"ak-z"};